"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.deleteOwnPathes = deleteOwnPathes;
exports.drawOwnValuePathes = drawOwnValuePathes;
exports.getOptions = getOptions;
exports.renderOwnPathes = renderOwnPathes;
var _lodash = _interopRequireDefault(require("lodash"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function drawOwnValuePathes(ref, scales, ownValues, strokeColor, ownValueStrokeWidth) {
  let {
    left,
    bottom
  } = scales;
  let groups = ref.current.chartRef.current.querySelectorAll('.cds--cc--axes .cds--cc--boxplot')[0];
  ownValues.forEach((value, index) => {
    let x = bottom(value);
    let bandwidth = left.bandwidth();
    let reverseIndex = groups.childNodes.length - 1 - index;
    let HALF_BAR_HEIGHT = 8;
    let y = bandwidth / 2 + (reverseIndex * bandwidth - HALF_BAR_HEIGHT);
    let path = createPath(x, y, 'own-value', ownValueStrokeWidth, strokeColor);
    groups.childNodes[index]?.appendChild(path);
  });
}
function createPath(x, y, className, ownValueStrokeWidth, strokeColor) {
  let ns = 'http://www.w3.org/2000/svg';
  let path = document.createElementNS(ns, 'path');
  path.setAttribute('class', className);
  path.setAttribute('stroke-width', ownValueStrokeWidth);
  path.setAttribute('stroke', strokeColor);
  path.setAttribute('d', `M${x} ${y} V${y + 16} Z`);
  return path;
}
function deleteOwnPathes(ref) {
  let boxGroups = ref?.querySelectorAll('.box-group') || [];
  boxGroups.forEach(group => {
    let ownValue = group.querySelector('.own-value');
    ownValue?.remove();
  });
}
function renderOwnPathes(ref, chartRef, ownValues, ownValueStroke, ownValueStrokeWidth) {
  deleteOwnPathes(chartRef);
  let scales = ref.current.chart.model.services.cartesianScales.scales;
  drawOwnValuePathes(ref, scales, ownValues, ownValueStroke, ownValueStrokeWidth);
}
function getOptions(overridingOptions, isMobile, width) {
  let defaultOptions = {
    title: '',
    axes: {
      bottom: {
        mapsTo: 'value',
        ticks: {
          rotation: width < 672 ? "always" : "never"
        }
      },
      left: {
        scaleType: 'labels',
        mapsTo: 'group',
        truncation: {
          threshold: isMobile ? 10 : 100,
          numCharacter: isMobile ? 10 : 100
        }
      }
    },
    width: '100%',
    toolbar: {
      enabled: false
    },
    stroke: '#000000',
    fill: '#a8a8a8',
    ownValueStroke: '#e41b13',
    ownValueStrokeWidth: '3'
  };
  return _lodash.default.merge(defaultOptions, overridingOptions);
}